"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchFilterPipe = void 0;
class SearchFilterPipe {
    transform(items, filter, defaultFilter) {
        if (!filter) {
            return items;
        }
        if (filter.isSearchData === undefined || filter.isSearchData === false) {
            if (items !== null && items !== undefined) {
                return items;
            }
        }
        // if (!Array.isArray(items)) {
        //   return items;
        // }
        if (filter && Array.isArray(items)) {
            const filterKeys = Object.keys(filter);
            if (defaultFilter) {
                return items.filter((item) => filterKeys.reduce((x, keyName) => (x && new RegExp(filter[keyName], 'gi').test(item[keyName])) || filter[keyName] === '', true));
            }
            else {
                return items.filter((item) => filterKeys.some((keyName) => 
                // return new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] === '';
                new RegExp(filter[keyName], 'gi').test(this.removeSpecialCharacters(item[keyName])) || filter[keyName] === ''));
            }
        }
    }
    removeSpecialCharacters(searchTextQuery) {
        if (searchTextQuery) {
            searchTextQuery = searchTextQuery.replace(/\(|\)|-| /g, '');
            return searchTextQuery;
        }
    }
}
exports.SearchFilterPipe = SearchFilterPipe;
//# sourceMappingURL=searchfilter.pipe.js.map